import HObject from '@/core/HObject.js'
import * as BABYLON from 'babylonjs'

export default class Section extends HObject {
  static meshes = []
  static loadRequest = false
  constructor (hObject) {
    super(hObject.name, hObject.type, hObject.allowRegistration)
    this.init(hObject)
    this.inQueue = false
  }

  loadObject () {
    let hObject = this
    this.registered = true
    Section.loadRequest = true
    BABYLON.SceneLoader.LoadAssetContainerAsync('static/assets/Section/', 'section.babylon', window.scene).then(function (container) {
      for (let i = 0; i < container.meshes.length; i++) {
        container.meshes[i].isVisible = false
        //  container.meshes[i].name = 'original.outdoor.section.' + container.meshes[i].name
      }
      hObject.lod(container.meshes, 1000)
      container.addAllToScene()

      Section.meshes = container.meshes
    })
  }

  register () {
    if (Section.meshes.length) { // Se puede registrar el objeto puesto que ya se pueden crear instancias
      // Se marca que ya queda registrado, para que en un siguiente registro no se registre mas de una vez
      this.registered = true

      let newInstances = []

      for (let i = 0; i < Section.meshes.length; i++) {
        newInstances.push(Section.meshes[i].createInstance(Section.meshes[i].name))
      }

      for (let i = 0; i < Section.meshes.length; i++) {
        newInstances.push(Section.meshes[i].createInstance(Section.meshes[i].name + '_B'))
        newInstances[newInstances.length - 1].rotation.y = -180 * Math.PI / 4
      }

      this.objectConfigurations(newInstances)

      this.setup()
    } else {
      if (Section.loadRequest === false) { // La primera vez que se desea registrar el objeto se debe cargar desde el servidor
        this.loadObject()
      }
      // Se agrega el objeto a la cola para reintentar posteriormente
      if (!this.inQueue) { // Se agrega sólo si aún no se ha agregado a la cola
        this.inQueue = true
        window.hScene.hObjectsRegisterQueue.push(this)
      }
    }
  }

  setup () {
    // Set activators
    // this.getMeshByName('activator.003').checkCollisions = false
    // this.getMeshByName('activator.003').material = window.scene.getMaterialByName('activator')

    // this.getMeshByName('activator.002').checkCollisions = false
    // this.getMeshByName('activator.002').material = window.scene.getMaterialByName('activator')

    // this.getMeshByName('activator.001').checkCollisions = false
    // this.getMeshByName('activator.001').material = window.scene.getMaterialByName('activator')

    // this.getMeshByName('activator').checkCollisions = false
    // this.getMeshByName('activator').material = window.scene.getMaterialByName('activator')

    if (this.getMeshByName('door_activator')) {
      this.getMeshByName('door_activator').dispose()
    }
    if (this.getMeshByName('band_activator')) {
      this.getMeshByName('band_activator').dispose()
    }
    if (this.getMeshByName('door_activator_B')) {
      this.getMeshByName('door_activator_B').dispose()
    }
    if (this.getMeshByName('band_activator_B')) {
      this.getMeshByName('band_activator_B').dispose()
    }

    if (this.getMeshByName('door1_B')) {
      this.getMeshByName('door1_B').dispose()
    }
    if (this.getMeshByName('door2_B')) {
      this.getMeshByName('door2_B').dispose()
    }

    // this.getMeshByName('door_activator').isVisible = false
    // this.getMeshByName('band_activator').isVisible = false
    // this.getMeshByName('activator.002').isVisible = false
    // this.getMeshByName('activator.003').isVisible = false

    // // Use door or side
    // if (typeof this.options['entryA'] !== 'undefined' && this.options['entryA'] === true) {
    //   this.getMeshByName('root.006').dispose()
    //   this.getMeshByName('root.003').dispose()
    //   this.getMeshByName('root.005').dispose()
    //   this.getMeshByName('root.004').dispose()
    // }

    // // Use door or side
    // if (typeof this.options['entryB'] !== 'undefined' && this.options['entryB'] === true) {
    //   this.getMeshByName('root.008').dispose()
    //   this.getMeshByName('root.011').dispose()
    //   this.getMeshByName('root.010').dispose()
    //   this.getMeshByName('root.009').dispose()
    //   this.getMeshByName('door1.001').dispose()
    //   this.getMeshByName('door2.001').dispose()
    // }
  }

  openDoor1 () {
    // console.log('Registrado:')
    // console.log(this.register)
    if (this.register) {
      window.scene.getMeshByName('TestGeneric2.Prueba.entry').position.y += 14
    }
  }
  // activate_door () {
  //   console.log('...')
  // }
}



// WEBPACK FOOTER //
// ./src/hobjects/Section.js